import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { Autocomplete, TextField, Box, Chip, Button } from "@mui/material";
import {
  AddButton,
  CancelButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { useSelector, useDispatch } from "react-redux";
import {
  assignuserToCycle,
  getCycleAssignedUsers,
} from "../../../../../redux/features/appraisalSlice";
import useHandleApiResponse from "../../../../../Hooks/useHandleApiResponse";

const IncludeUser = ({ cycleId, setUpdateValidation }) => {
  const [open, setOpen] = useState(false);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const dispatch = useDispatch();
  const { allUsers } = useSelector((state) => state.general);
  const { loading } = useSelector((state) => state.appraisal);

  const handleChange = (event, value) => {
    // Extract just the userIds from selected objects
    const ids = value.map((user) => user.userID);
    setSelectedUserIds(ids);
  };
  const handleApiResponse = useHandleApiResponse();
  const handleAddUser = () => {
    const data = { id: cycleId, userIds: [...selectedUserIds] };
    dispatch(assignuserToCycle(data)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
          dispatch(getCycleAssignedUsers(cycleId));
          setUpdateValidation(true);
        },
        onFailed: () => {
          console.log("Something went wrong");
        },
      });
    });
  };

  return (
    <Box>
      <GlobalDialog
        open={open}
        setOpen={setOpen}
        title={"Include User"}
        fullWidth
        maxWidth={"sm"}
        closeButton={true}
        popupButton={
          <Button
            variant="contained"
            size="small"
            onClick={() => setOpen(true)}
            sx={{ borderRadius: 3 }}
          >
            Include User
          </Button>
        }
        content={
          <Box>
            <Autocomplete
              multiple
              options={allUsers}
              getOptionLabel={(option) => option.name}
              onChange={handleChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Users"
                  placeholder="Choose..."
                />
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    label={option.name}
                    {...getTagProps({ index })}
                    key={option.userID}
                  />
                ))
              }
            />
          </Box>
        }
        actionButton={
          <>
            <CancelButton size={"small"} action={() => setOpen(false)}>
              Cancel
            </CancelButton>
            <AddButton disabled={loading} action={handleAddUser} size={"small"}>
              {loading ? "Please Wait..." : "Add user"}
            </AddButton>
          </>
        }
      />
    </Box>
  );
};

export default IncludeUser;
